import PowerDate from '#metatypes/power_date.js'
import PowerBool from '#metatypes/power_bool.js'
import { define, type, auto, Record, Collection } from 'type-r'
import ConsentForm from './consent'
import LowerLidEnum from '#metatypes/lower_lid_enum.js'
import UpperLidEnum from '#metatypes/upper_lid_enum.js'

@define
export default class BlepharoplastyForm extends ConsentForm {
    @(type(UpperLidEnum).required.as) upperLidSide: string
    @(type(LowerLidEnum).required.as) lowerLidSide: string    
}
